import { render, staticRenderFns } from "./discounts-list.vue?vue&type=template&id=5a2b4efc&scoped=true"
import script from "./discounts-list.vue?vue&type=script&lang=js"
export * from "./discounts-list.vue?vue&type=script&lang=js"
import style0 from "./discounts-list.vue?vue&type=style&index=0&id=5a2b4efc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2b4efc",
  null
  
)

export default component.exports